<script>
import VueSlideBar from "vue-slide-bar";

import ErrorAlert from "@/components/errorAlert";
import Multiselect from "vue-multiselect";
import axios from "axios";
import Vue from "vue";
import validation from "@/helpers/validation";

const companyStatuses = {
  0: 'New',
  1: 'Active',
  // 2: 'Suspended'
}

export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueSlideBar,
    ErrorAlert,
    Multiselect,
  },
  async created() {
    this.initializeFieldsFromState();
  },
  computed: {
    clientId() {
      return this.$route.params.clientId;
    }
  },
  data() {
    return {
      forms: {
        companySettings: {
          name: 'Company Settings',
          icon: 'fas fa-map-marker-alt',
          fields: {
            status: {
              name: 'status',
              value: '',
              options: Object.keys(companyStatuses),
              required: true,
              error: false,
            },
            platformFee: {
              name: 'Platform fee',
              value: 0,
              required: true,
              error: false
            },
            paymentDueDays: {
              name: 'Payment due days',
              value: '',
              required: true,
              error: false
            },
            canReceiveInvoice: {
              name: 'Client can receive invoice',
              value: '',
              options: ['enabled', 'disabled'],
              required: true,
              error: false
            },
          }
        },
      }
    };
  },
  methods: {
    initializeFieldsFromState() {
      this.$store.commit('errorBag/CLEAR');

      this.forms.companySettings.fields.status.value = this.client.client.status
      this.forms.companySettings.fields.platformFee.value = Math.round(this.client.client.platform_fee * 100)
      this.forms.companySettings.fields.paymentDueDays.value = this.client.client.payment_due_days
      this.forms.companySettings.fields.canReceiveInvoice.value = this.client.client.can_receive_invoice ? 'enabled' : 'disabled';
    },
    async complete () {
      this.$store.commit('errorBag/CLEAR');

      for (let form in this.forms) {
        this.validate(form)
      }

      try{
        this.$store.commit('loader/START_LOADING');

        const { data } = await axios.put(`/admin/client/${this.clientId}/settings`, {
          status: this.forms.companySettings.fields.status.value,
          platform_fee: this.forms.companySettings.fields.platformFee.value / 100,
          payment_due_days: this.forms.companySettings.fields.paymentDueDays.value,
          can_receive_invoice: this.forms.companySettings.fields.canReceiveInvoice.value.toLowerCase() === 'enabled' ? true : false,
        });
        this.$emit('update:client', data);

        Vue.swal({
          position: "top",
          icon: "success",
          title: "Saved!",
          showConfirmButton: false,
          timer: 1000
        });
      } catch (error) {
        // eslint-disable-next-line no-empty
      } finally{
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.initializeFieldsFromState();
    },
    validateForms() {
      let isValid = true
      for (let form in this.forms) {
        isValid = isValid && this.validate(form);
      }

      return isValid;
    },
    validate(formName) {
      let isValid = true;
      let fields = this.forms[formName].fields;
      for (let field in this.forms[formName].fields) {

        // check if field is empty
        if(fields[field].required && fields[field].value === '') {
          fields[field].error = true;
          isValid = false;
        }

        // check special type of fields
        if(fields[field].type && validation[fields[field].type] !== undefined) {
          if(!validation[fields[field].type](fields[field].value)) {
            fields[field].error = true;
            isValid = false;
          }
        }
      }

      return isValid
    },
    statusCaption(status) {
      return companyStatuses[status];
    },
  }
}
</script>

<template>
  <form ref="client-profile" autocomplete="on" @submit.prevent="complete">
    <error-alert></error-alert>
    <div>
      <div class="p-3">
        <h3 class="mb-4">Company Settings</h3>
        <div class="row">
          <div class="col-12">
            <div>
              <div class="form-group row mb-3">
                <label class="col-12 col-md-5 col-form-label">Status</label>
                <div class="col-12 col-md-7">
                  <multiselect  required
                                class="text-capitalize"
                                :class="{ invalid: forms.companySettings.fields.status.error }"
                                v-model.number="forms.companySettings.fields.status.value"
                                :options="forms.companySettings.fields.status.options"
                                :custom-label="statusCaption"
                                @input="forms.companySettings.fields.status.error = false"
                                :multiple="false"></multiselect>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-12 col-md-5 col-form-label">Platform fee in %</label>
                <div class="col-12 col-md-7">
                  <input
                      required
                      type="number"
                      :min="0"
                      :max="100"
                      class="form-control"
                      @input="forms.companySettings.fields.paymentDueDays.error = false"
                      :class="{'is-invalid': forms.companySettings.fields.paymentDueDays.error}"
                      :name="forms.companySettings.fields.paymentDueDays.name.toLowerCase()"
                      :placeholder="forms.companySettings.fields.paymentDueDays.placeholder"
                      v-model.number="forms.companySettings.fields.platformFee.value"
                  />
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-12 col-md-5 col-form-label">Payment due days</label>
                <div class="col-12 col-md-7">
                  <input
                      required
                      type="number"
                      min="0"
                      max="365"
                      class="form-control"
                      @input="forms.companySettings.fields.paymentDueDays.error = false"
                      :class="{'is-invalid': forms.companySettings.fields.paymentDueDays.error}"
                      :name="forms.companySettings.fields.paymentDueDays.name.toLowerCase()"
                      :placeholder="forms.companySettings.fields.paymentDueDays.placeholder"
                      v-model.number="forms.companySettings.fields.paymentDueDays.value"
                  />
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-12 col-md-5 col-form-label">Client can receive invoice</label>
                <div class="col-12 col-md-7">
                  <multiselect  required
                                class="text-capitalize"
                                :class="{ invalid: forms.companySettings.fields.canReceiveInvoice.error }"
                                v-model="forms.companySettings.fields.canReceiveInvoice.value"
                                :options="['enabled', 'disabled']"
                                @input="forms.companySettings.fields.canReceiveInvoice.error = false"
                                :multiple="false"></multiselect>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>

    <div>

    </div>
    <div class="row p-3">
      <div class="col-md-12 text-right">
        <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button type="submit" variant="primary" class="ml-2" >Save</b-button>
      </div>
    </div>
  </form>
</template>

<style scoped>

</style>
